export const stem = "https://storage.googleapis.com/public_viteslink_storage/images/invitation03/stem.png";
export const stem02 = "https://storage.googleapis.com/public_viteslink_storage/images/invitation03/tree_branch.png";
